// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "js/" + "actioncable" + "-" + "17bd66fa0bf6b1c9" + ".chunk.js"
}